import { render, staticRenderFns } from "./SupplierRawMaterialAdditivesPreservatives.vue?vue&type=template&id=4d3d1102&scoped=true"
import script from "./SupplierRawMaterialAdditivesPreservatives.vue?vue&type=script&lang=js"
export * from "./SupplierRawMaterialAdditivesPreservatives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3d1102",
  null
  
)

export default component.exports